import React from "react";
import "../../../auto-mapper/AutoMapperProvider.js";
import { useAutoMapper } from "../../../auto-mapper/hooks.js";
import "../../../components/filter/FilterGroupNew.js";
import "moment-timezone";
import "../../../components/input/validation.js";
import "../../../components/input/DatePicker.js";
import "../../../components/input/DateRangePicker.js";
import "../../../components/input/StyledInput.js";
import "../../../components/input/FormInput.js";
import "../../../components/input/StyledFormInputHoc.js";
import { getMirrorObject } from "../../../utils/object.js";
import "react-intl";
import "../../../components/input/DateSinglePicker.localize.js";
import "../../../components/input/hooks.js";
import "@mui/material";
import "../../../components/filter/dateRangeFilter/DateRangeFilter.js";
import "../../../components/filter/date-filter/DateFilter.js";
import "../../../components/filter/TextFilterWithDropdown.js";
import { withQueryFilter } from "../../../components/filter/QueryFilterHoc.js";
import "../../../components/filter/MultiStepFilterDrawer.js";
import "../../../components/filter/dateRangeFilter/MultiStepFilterDatePicker.js";
import "../../../components/select/Select.js";
import "../../../components/filter/TextFilter.js";
import "../../../components/filter/valueRangeFilter/ValueRangeFilter.js";
import "../../../components/filter/dateRangeFilter/localized.js";
import "../../../components/filter/dateRangeFilter/DateRangeHistoricalFilter.js";
import "../../../components/filter/MultiStepFilterApplyButton.js";
import "../../../components/filter/MultiStepFilterInput.js";
import "../../../components/filter/MultiStepFilterHoc.js";
import "../../../components/chip/ChipRenderer.js";
import "../../../components/select/selectStyle.js";
import "../../../components/select/MultiSelectFooter.js";
import "../../../components/select/MultiSelect.js";
import "../../../components/select/MultiSelectItem.js";
import "../../../components/select/SelectArrowIcon.js";
import "../../../components/select/VirtualizedMultiSelectOptionList.js";
import "../../../components/select/SingleSelect.js";
import "../../../components/select/MultiSelectWithExclude.js";
import "../../../components/select/MultiSelectTextCounterWithTooltip.js";
import "../../../components/filter/PhoneFilter.js";
import { ServerLicenseTypeTypeName, LicenseTypeTypeName } from "../../brand-license/constants.js";
import "@automapper/core";
import "typesafe-actions";
import "rxjs";
import "rxjs/operators";
import "@opentelemetry/api";
import "../../../otel/TraceProvider.js";
import "react-error-boundary";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "redux-observable";
import "../../../api/types.js";
import "immer";
import "@apollo/client/errors";
import "@apollo/client";
import "graphql";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import "../../../redux-folder/async-action/action.js";
import "../../../redux-folder/error-handling/action.js";
import "../../../redux-folder/actions.js";
import "fast-deep-equal/es6";
import "redux";
import "../../../redux-folder/entity/epics.js";
import "normalizr";
import "../../../redux-folder/entity/EntityProvider.js";
import "../../../redux-folder/realtime/RealtimeNotification.js";
import "reselect";
import "react-redux";
import "react-router";
import "../../country/components/CountryFilter.js";
import "../../brand-license/components/BrandProvider.js";
import "react-oidc-context";
import "oidc-client-ts";
import "../../../components/alerts/NoAccessInfoMessage.js";
import "../../brand-license/components/LicenseSelect.js";
import "../../brand-license/components/BrandSelect.js";
import "../../../components/circle-box/CircleBoxWithText.js";
import "../../../components/label/EmptyLabel.js";
import "../../../components/label/LabelHoc.js";
import "../../../components/tooltip/Tooltip.js";
import "../../../components/tooltip/AutoAdjustedWidthTooltip.styles.js";
import "../../../components/tooltip/AutoAdjustedComplexTooltip.styles.js";
import "../../../components/tooltip/MultiLineAutoAdjustedWidthTooltip.js";
import "@mui/material/colors";
import "@mui/material/locale";
import "@mui/material/styles";
import "../../../style/hooks.js";
import "../../../components/circle-box/CircleBox.js";
import { UserProfileFilters } from "./Filters.js";
function UserProfileFiltersAdapter({ model, onChange, ...props }) {
  const mapper = useAutoMapper();
  const clientTextKeyToServer = {
    uid: "uid",
    username: "username",
    referrerId: "referrerId",
    firstName: "firstName",
    lastName: "lastName",
    nickname: "nickname",
    labels: "labels",
    email: "email",
    registrationCountry: "registrationCountry",
    loginCountry: "loginCountry",
    marketingCode: "marketingCode",
    networks_PKW: "networks_PKW",
    networks_BL: "networks_BL",
    uid_un_fn_ln_em_ph_rmc: "uid_un_fn_ln_em_ph_rmc",
    uid_un_nn_em_sc_nuid: "uid_un_nn_em_sc_nuid",
    uid_un_fn_ln_labels_em_ni_rmc_phone_r: "uid_un_fn_ln_labels_em_ni_rmc_phone_r",
    uid_un_nn_em_l_sc_nuid_ref: "uid_un_nn_em_l_sc_nuid_ref",
    uid_un_rmc_em: "uid_un_rmc_em",
    uid_username_nickname_referralCode: "uid_un_nn_rc",
    nationalId: "nationalId",
    boUserId: "boUserId",
    boUserId_uid: "boUserId_uid",
    personalReferralCode: "personalReferralCode"
  };
  const serverTextKeyToClient = getMirrorObject(clientTextKeyToServer);
  const filterModel = {
    text: model?.text ? { ...model?.text, option: serverTextKeyToClient[model?.text?.option] } : null,
    uid: model?.uid,
    username: model?.username,
    nickname: model?.nickname,
    labels: model?.labels,
    email: model?.email,
    phone: model?.phone,
    security_cases: model?.security_cases,
    networks_PKW: model?.networks_PKW,
    networks_BL: model?.networks_BL,
    referrerId: model?.referrerId,
    accountStatus: model?.accountStatus,
    firstName: model?.firstName,
    lastName: model?.lastName,
    registrationCountry: model?.registrationCountry,
    registrationDate: {
      from: model?.joinedFrom,
      to: model?.joinedTo
    },
    loginCountry: model?.loginCountry,
    casinoGgr: {
      from: model?.casinoGgrFrom,
      to: model?.casinoGgrTo
    },
    pokerGgr: {
      from: model?.pokerGgrFrom,
      to: model?.pokerGgrTo
    },
    sportsGgr: {
      from: model?.sportsGgrFrom,
      to: model?.sportsGgrTo
    },
    depositTotal: {
      from: model?.depositTotalFrom,
      to: model?.depositTotalTo
    },
    withdrawalTotal: {
      from: model?.withdrawalTotalFrom,
      to: model?.withdrawalTotalTo
    },
    marketingCode: model?.marketingCode,
    agent: {
      agentId: model?.referrerPlayerId,
      isDownstream: model?.isDownstream
    },
    channel: model?.channel,
    licenseType: (model?.licenseType ?? []).map(
      (i) => mapper.map(i, ServerLicenseTypeTypeName, LicenseTypeTypeName)
    ),
    nationalId: model?.nationalId,
    aal: model?.aal,
    brand: model?.brand
  };
  function handleChange(model2) {
    const result = {
      text: model2?.text ? { ...model2?.text, option: clientTextKeyToServer[model2?.text?.option] } : void 0,
      uid: model2?.uid,
      username: model2?.username,
      nickname: model2?.nickname,
      labels: model2?.labels,
      email: model2?.email,
      phone: model2?.phone,
      security_cases: model2?.security_cases,
      networks_PKW: model2?.networks_PKW,
      networks_BL: model2?.networks_BL,
      referrerId: model2?.referrerId,
      accountStatus: model2?.accountStatus,
      firstName: model2?.firstName,
      lastName: model2?.lastName,
      registrationCountry: model2?.registrationCountry,
      joinedFrom: model2?.registrationDate?.from,
      joinedTo: model2?.registrationDate?.to,
      loginCountry: model2?.loginCountry,
      casinoGgrFrom: model2?.casinoGgr?.from,
      casinoGgrTo: model2?.casinoGgr?.to,
      pokerGgrFrom: model2?.pokerGgr?.from,
      pokerGgrTo: model2?.pokerGgr?.to,
      sportsGgrFrom: model2?.sportsGgr?.from,
      sportsGgrTo: model2?.sportsGgr?.to,
      depositTotalFrom: model2?.depositTotal?.from,
      depositTotalTo: model2?.depositTotal?.to,
      withdrawalTotalFrom: model2?.withdrawalTotal?.from,
      withdrawalTotalTo: model2?.withdrawalTotal?.to,
      marketingCode: model2?.marketingCode,
      referrerPlayerId: model2?.agent?.agentId,
      isDownstream: model2?.agent?.isDownstream,
      channel: model2?.channel,
      licenseType: model2?.licenseType?.map(
        (i) => mapper.map(i, LicenseTypeTypeName, ServerLicenseTypeTypeName)
      ),
      nationalId: model2?.nationalId,
      aal: model2?.aal,
      brand: model2?.brand
    };
    onChange(result);
  }
  return /* @__PURE__ */ React.createElement(UserProfileFilters, { model: filterModel, onChange: handleChange, ...props });
}
const UserProfileQueryFilters = withQueryFilter(UserProfileFiltersAdapter, {
  agentId_nickname_username_referralCode: ["uid_un_nn_rc", "uid", "username", "nickname", "personalReferralCode"],
  uid_email_username_marketingCode: ["uid_un_rmc_em", "uid", "username", "email", "marketingCode"]
});
export {
  UserProfileQueryFilters
};
//# sourceMappingURL=QueryFilters.js.map
